import { render } from "./EnqueteComponentItem.vue?vue&type=template&id=c5c2d626"
import script from "./EnqueteComponentItem.vue?vue&type=script&lang=js"
export * from "./EnqueteComponentItem.vue?vue&type=script&lang=js"

import "./EnqueteComponentItem.vue?vue&type=style&index=0&id=c5c2d626&lang=css"

import exportComponent from "D:\\ProjetosCodes\\Ideias\\front\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__